import { defineMessages } from 'react-intl';

const translations = {
  page: {
    title: {
      id: 'selectAddress.title',
      defaultMessage: 'Select billing address',
      description: 'Title of the select billing address drawer',
    },
    createAddress: {
      title: {
        id: 'createAddress.title',
        defaultMessage: 'Create address',
        description: 'Title of the create address drawer',
      },
    },
    button: {
      create: {
        id: 'selectAddress.button.create',
        defaultMessage: 'Add address',
        description: 'Label of the add address button in the address drawer',
      },
    },
    groups: {
      contact: {
        id: 'selectAddress.groups.contact',
        defaultMessage: 'Contact',
        description: 'Title of the contact group in the select address drawer',
      },
      organisation: {
        id: 'selectAddress.groups.organisation',
        defaultMessage: 'Organisation',
        description: 'Title of the organisation group in the select address drawer',
      },
      other: {
        id: 'selectAddress.groups.other',
        defaultMessage: 'Other',
        description: 'Title of the other group in the select address drawer',
      },
    },
  },
  feedback: {
    addressCreated: {
      id: 'createAddress.feedback.addressCreated',
      defaultMessage: 'Address added',
      description: 'feedback on the successful add of a new address',
    },
    addressNotCreated: {
      id: 'createAddress.feedback.addressNotCreated',
      defaultMessage: 'Address could not be created',
      description: 'feedback on a failed attempt to create a new address',
    },
  },
};

export default defineMessages(translations);
